// extracted by mini-css-extract-plugin
export default {"benefits":"BenefitsSection_benefits__hnvoN","cards":"BenefitsSection_cards__zUvZ8","card":"BenefitsSection_card__66S-n"};